import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Tag,
  notification,
  Spin,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllCourse } from "../../Graphs/Course/listCourse";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { UserOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditModal } from "./EditModal";
import { deleteCourseSessionTopic } from "../../Graphs/CourseSessionTopic/deleteCourseSessionTopic";
import { editCourseSessionTopic } from "../../Graphs/CourseSessionTopic/editCourseSessionTopic";
import { changeStatus } from "../../Graphs/CourseSessionTopic/changeStatus";
import { getAllCourseSessionTopic } from "../../Graphs/CourseSessionTopic/listCourseSessionTopic";
import { checkPermission } from "../AdminUser/CheckAdminPermission";

const NativeSelect = ({ value, onChange, children, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={className}
      style={{
        padding: "3px 8px",
        borderRadius: "4px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        outline: "none",
        cursor: "pointer",
        marginLeft: "8px",
        height: "28px"
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) return null;
        return <option value={child.props.value}>{child.props.children}</option>;
      })}
    </select>
  );
};

class CourseSessionTopicRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedCourseSessionTopic =
      this.getLimitedCourseSessionTopic.bind(this);
  }

  async componentDidMount() {
    const { course_id } = this.props;

    // Hide Course column if viewing within a specific Course detail page
    if (course_id) {
      this.columns = this.columns.filter((item) => item.key !== "course");
    }

    // Keep existing state logic
    this.setState({
      data: this.props.data,
      isLoading: false,
      userSelectedData: null,
    });
  }

  modalRef;

  async getLimitedCourseSessionTopic(pagination) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      }
    });
  }

  listSearchCourseSessionTopicData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionTopicData,
        setListCourseSessionTopicDataTotal,
        searchText,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let courseData = await getAllCourse(authToken, searchText, start, end);

      if (courseData.status === 200) {
        //set user Data
        // await setListCourseSessionTopicData(courseData.data.docs);
        await setListCourseSessionTopicData(courseData.data);
        await setListCourseSessionTopicDataTotal(courseData.total);

        this.setState({
          isLoading: false,
          // data: courseData.data.docs,
          data: courseData.data,
        });
      } else if (courseData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  listCourseSessionTopicData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionTopicData,
        setListCourseSessionTopicDataTotal,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let courseSessionTopicData = await getAllCourseSessionTopic(
        authToken,
        start,
        end,
        course_id
      );

      if (courseSessionTopicData.status === 200) {
        //set user Data
        // await setListCourseSessionTopicData(courseSessionTopicData.data.docs);
        await setListCourseSessionTopicData(courseSessionTopicData.data);
        await setListCourseSessionTopicDataTotal(courseSessionTopicData.total);

        this.setState({
          isLoading: false,
          data: courseSessionTopicData.data,
        });
      } else if (courseSessionTopicData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  showModal(item) {
    console.log("open modal", item);
    this.setState({
      courseSelectedData: item,
      isOpen: true
    });
  }

  handleDetailsModalclose() {
    this.setState({
      courseSelectedData: null,
      isOpen: false
    });
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        const { current, pageSize } = this.state.pagination;
        const serialNumber = (current - 1) * pageSize + index + 1;
        return (
          <div>
            <span>{serialNumber}</span>
          </div>
        );
      },
    },
    {
      title: "Name",
      key: "name",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Name">
                <div>{item.name ? item.name : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Course",
      key: "course",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Course">
                <div>
                  {item.courseData &&
                    item.courseData[0] &&
                    item.courseData[0].name
                    ? item.courseData[0].name
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    // {
    //   title: "Module",
    //   key: "Module",
    //   render: (text, item, index) => {
    //     return (
    //       <div>
    //         <strong>
    //           <Tooltip placement="bottom" title="module">
    //             <div>{item.moduel_id && item.moduleData[0]['title'] ? item.moduleData[0]['title'] : "-"}</div>
    //           </Tooltip>
    //         </strong>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Session",
      key: "session",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="session">
                <div>
                  {item.sessionData &&
                    item.sessionData[0] &&
                    item.sessionData[0].name
                    ? item.sessionData[0].name
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Type",
      key: "type",
      render: (text, item, index) => {
        return (
          <div>
            <Tooltip placement="bottom" title="Type">
              {item.topic_type === "study" ? (
                <Tag color="blue">Study</Tag>
              ) : (
                <Tag color="green">Quiz</Tag>
              )}
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "isActive",
      key: "is_active",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "course", "edit");
        return (
          <div>
            {item.is_active != null ? (
              <Tooltip placement="bottom" title="IS Active">
                {
                  <Switch
                    checked={item.is_active}
                    style={{
                      backgroundColor: item.is_active
                        ? this.props.primaryColor
                        : "#bababa",
                    }}
                    onChange={this.onChange.bind(this, item)}
                    disabled={loginUserData.role === "corporate" || !canEdit}
                  />
                }
              </Tooltip>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      width: 130,
      key: "action",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "course", "edit");
        const canDelete = checkPermission(loginUserData, "course", "delete");
        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            <div mr="5px" style={{ float: "left" }}>
              <Tooltip placement="bottom" title="Edit">
                <Button
                  shape="circle"
                  icon={<EditOutlined />}
                  onClick={() => {
                    this.showModal(item);
                  }}
                  disabled={!canEdit}
                  style={{
                    cursor: canEdit ? "pointer" : "not-allowed",
                    opacity: canEdit ? 1 : 0.5,
                    pointerEvents: canEdit ? "auto" : "none"
                  }}
                />
              </Tooltip>
            </div>
            <div
              ml="15px"
              mr="5px"
              style={{ float: "left", marginLeft: "10px" }}
            >
              <Tooltip placement="bottom" title="Delete">
                {canDelete ? (
                  <Popconfirm
                    onConfirm={this.deleteSessionTopicData.bind(this, item)}
                    title="Are you sure you want to delete Topic?"
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                ) : (
                  <Button
                    shape="circle"
                    icon={<DeleteOutlined />}
                    disabled
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                      pointerEvents: "none"
                    }}
                  />
                )}
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  async deleteSessionTopicData(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionTopicData,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteCourseSessionTopic(authToken, item._id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete Topic Status",
          description: "Successfully deleted",
        });

        await this.listCourseSessionTopicData(0, 1000000);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete Topic Status",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async onChange(item, checked) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item._id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change Topic Status",
          description: "Successfully changed status",
        });
        this.listCourseSessionTopicData(0, 1000000);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      notification["error"]({
        message: "Change Topic Status",
        description: err,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  editSubmit = async (courseObject, courseId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await editCourseSessionTopic(
        authToken,
        courseObject,
        courseId
      );
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Topic Status",
          description: "Successfully edited",
        });
        this.handleDetailsModalclose();
        this.listCourseSessionTopicData(0, 1000000);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        notification["error"]({
          message: "Edit Topic Status",
          description: statusData.message || "There was a problem in editing the topic",
        });
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Topic Status",
        description: e.message || "There was a problem in editing the topic",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedCourseSessionTopic(pagination)
    );
  }

  render() {
    const { isLoading } = this.state;
    const {
      authToken,
      listCourseSessionTopicData,
      searchLoader,
      course_id,
      loginUserData,
      searchText,
      statusFilter,
      topicCourseFilter,
      topicSessionFilter,
      topicTypeFilter,
    } = this.props;

    let filteredTopicData = listCourseSessionTopicData || [];

    // Client-side search filter
    if (searchText && searchText.trim() !== "") {
      const query = searchText.toLowerCase().trim();
      filteredTopicData = filteredTopicData.filter(topic => {
        const name = (topic.name || "").toLowerCase();
        const courseName = (topic.courseData && topic.courseData[0] && topic.courseData[0].name || "").toLowerCase();
        const sessionName = (topic.sessionData && topic.sessionData[0] && topic.sessionData[0].name || "").toLowerCase();
        return name.includes(query) || courseName.includes(query) || sessionName.includes(query);
      });
    }

    // Client-side status filter
    if (statusFilter === "active") {
      filteredTopicData = filteredTopicData.filter(topic => topic.is_active);
    } else if (statusFilter === "inactive") {
      filteredTopicData = filteredTopicData.filter(topic => !topic.is_active);
    }

    // Client-side course filter
    if (topicCourseFilter && topicCourseFilter !== "all") {
      filteredTopicData = filteredTopicData.filter(topic => {
        const courseName = (topic.courseData && topic.courseData[0] && topic.courseData[0].name || "").trim();
        return courseName === topicCourseFilter.trim();
      });
    }

    // Client-side session filter
    if (topicSessionFilter && topicSessionFilter !== "all") {
      filteredTopicData = filteredTopicData.filter(topic => {
        const sessionName = (topic.sessionData && topic.sessionData[0] && topic.sessionData[0].name || "").trim();
        return sessionName === topicSessionFilter.trim();
      });
    }

    // Client-side type filter
    if (topicTypeFilter && topicTypeFilter !== "all") {
      filteredTopicData = filteredTopicData.filter(topic => {
        return (topic.topic_type || "").toLowerCase() === topicTypeFilter.toLowerCase();
      });
    }

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          dataSource={filteredTopicData}
          pagination={{
            total: filteredTopicData.length,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            selectComponentClass: NativeSelect,
            onChange: (e) => {
              if (e - 1) {
                this.counter = this.tempCounter =
                  (e - 1) * this.state.pagination.pageSize;
                return;
              }

              this.counter = 0;
              this.tempCounter = 0;
            },
          }}
          onChange={this.handleTableChange}
        />

        {this.state.courseSelectedData ? (
          <EditModal
            admin={false}
            visible={this.state.isOpen}
            onClose={this.handleDetailsModalclose.bind(this)}
            courseSelectedData={this.state.courseSelectedData}
            onSubmit={this.editSubmit}
            course_id={course_id}
            authToken={authToken}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  listCourseSessionTopicData:
    state.coursesessiontopic.listCourseSessionTopicData,
  listCourseSessionTopicDataTotal:
    state.coursesessiontopic.listCourseSessionTopicDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
  statusFilter: state.auth.statusFilter,
  topicCourseFilter: state.auth.topicCourseFilter,
  topicSessionFilter: state.auth.topicSessionFilter,
  topicTypeFilter: state.auth.topicTypeFilter,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListCourseSessionTopicData: (listCourseSessionTopicData) => {
      dispatch({
        type: "SET_LIST_COURSE_SESSION_TOPIC_DATA",
        listCourseSessionTopicData: listCourseSessionTopicData,
      });
    },
    setListCourseSessionTopicDataTotal: (listCourseSessionTopicDataTotal) => {
      dispatch({
        type: "SET_LIST_COURSE_SESSION_TOPIC_DATA_TOTAL",
        listCourseSessionTopicDataTotal: listCourseSessionTopicDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CourseSessionTopicRecordsTable));
